export interface IEventTicketCard {
    image?: string;
    file: File;
    fileName: string;
    button_text?: string;
    additional_text?: string;
    isPdf?: boolean;
}
